export const buildTime = '2026-10-23 11:12:17 UTC';
